<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div id="track">
      <div class="d-flex justify-content-between">
        <div>
          <a href="/ExhibitorServiceTW/">展覽列表</a><span>/</span
          ><em name="Exhibition"></em><span>/</span
          ><a href="javascript:history.back()">新聞稿</a
          ><span>/</span>建立新聞稿
        </div>
        <div>
          <span class="bold">登入帳號 :</span>
          <span> {{ UserId }}</span>
        </div>
      </div>
    </div>
    <!-- track end -->
    <!-- article -->
    <article>
      <div class="contentBox">
        <div>
          <div class="container">
            <h1>建立新聞稿</h1>
            <p class="my-3">&nbsp;</p>
            <p class="alert">
              <i class="fas fa-exclamation-circle"></i>
              請勿上傳與本展無關或是妨害社會善良風俗之內容，主辦單位有權刪除不適當的內容。
            </p>
            <p class="my-3">&nbsp;</p>

            <form id="form" @submit.prevent="AddNews">
              <input type="hidden" name="RegNo" />

              <p class="formTitle">官網狀態 <span class="red">*</span></p>
              <label
                ><input
                  type="radio"
                  name="Archived"
                  v-model="NewsArchive"
                  value="0"
                  class="largeItem"
                  checked
                />
                顯示
              </label>
              <label
                ><input
                  type="radio"
                  name="Archived"
                  v-model="NewsArchive"
                  value="1"
                  class="largeItem ml-2"
                />
                隱藏</label
              >
              <p class="clear"></p>
              <p class="my-3">&nbsp;</p>
              <p class="formTitle">新聞主旨 <span class="red">*</span></p>
              <div v-if="LocalExh">
                <div class="langTip">
                  <input
                    type="text"
                    name="NewsTopic"
                    class="maxText textStyle"
                    maxlength="50"
                    v-model="NewsTopic"
                    placeholder="限制為50字"
                  />
                  <span>中 </span>
                </div>
                <div id="error2"></div>
              </div>
              <p class="divider"></p>
              <div class="langTip">
                <input
                  type="text"
                  name="eNewsTopic"
                  class="maxText textStyle"
                  maxlength="100"
                  v-model="eNewsTopic"
                  placeholder="限制為100字元"
                />
                <span>EN</span>
              </div>
              <p class="my-3">&nbsp;</p>
              <p class="formTitle">相關連結</p>
              <div v-if="LocalExh">
                <div class="langTip">
                  <input
                    type="text"
                    name="NewsTopic"
                    class="maxText textStyle"
                    maxlength="200"
                    v-model="NewsLink"
                  />
                  <span>中 </span>
                </div>
              </div>
              <p class="divider"></p>
              <div class="langTip">
                <input
                  type="text"
                  name="eNewsTopic"
                  class="maxText textStyle"
                  maxlength="200"
                  v-model="eNewsLink"
                />
                <span>EN</span>
              </div>

              <p class="my-3">&nbsp;</p>
              <div v-if="LocalExh">
                <p class="formTitle">
                  新聞內容 (中) <span class="red">*</span>
                </p>

                <ckeditor
                  v-model="NewsContent"
                  :config="editorConfig"
                ></ckeditor>

                <p class="divider"></p>
                <div id="error"></div>
              </div>

              <p class="my-3">&nbsp;</p>
              <p class="formTitle">
                新聞內容 (English) <span class="red" v-if="!LocalExh">*</span>
              </p>

              <ckeditor
                v-model="eNewsContent"
                :config="editorConfig"
              ></ckeditor>

              <p class="my-3">&nbsp;</p>
              <div class="d-flex justify-content-center">
                <input type="submit" value="確定送出" class="btnStyle mr-4" />
                <div class="btnStyle btnGray" @click.prevent="backNewsPage">
                  返回
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";

// import './../../../../public/ckeditor'

export default {
  metaInfo() {
    return {
      title: "新聞稿 - 展昭參展商管理系統",
    };
  },

  data() {
    return {
      LocalExh: true,

      UserId: "",
      CSRF_Token: "",
      RegNo: "",
      // date: '',
      //form資訊
      NewsArchive: "0",
      NewsTopic: "",
      eNewsTopic: "",
      NewsLink: "",
      eNewsLink: "",
      NewsContent: "",
      eNewsContent: "",
      NewsAmount: "",
      lang: "tw",
    };
  },

  methods: {
    // AddNews() {
    //   const vm = this;

    //   if (vm.LocalExh) {
    //     if (!vm.NewsTopic || !vm.NewsContent) {
    //       $("html,body").animate({ scrollTop: 0 }, "slow");
    //       alert("輸入欄位不完整，請重新檢查！");

    //       if (!vm.NewsTopic) {
    //         $("#error2").html(
    //           "<span class='errorTextArea'>請填寫此欄位</span>"
    //         );
    //         $("#error").html("<p class='errorTextArea'></p>");

    //         if (!vm.NewsContent) {
    //           $("#error").html("<p class='errorTextArea'>請填寫此欄位</p>");
    //         }
    //       } else {
    //         $("#error2").html("<span class='errorTextArea'></span>");
    //         $("#error").html("<p class='errorTextArea'>請填寫此欄位</p>");
    //       }
    //     } else {
    //       if (!vm.NewsContent) {
    //         alert("輸入欄位不完整，請重新檢查！");
    //         $("#error").html("<p class='errorTextArea'>請填寫此欄位</p>");
    //       } else {
    //         // vm.NewsContent = CKEDITOR.instances['NewsContent'].getData()
    //         // vm.eNewsContent = CKEDITOR.instances['eNewsContent'].getData()

    //         const url = "/apiExhibitors/ExhibitorNews/";

    //         const info = {
    //           RegNo: vm.RegNo,
    //           NewsTopic: vm.NewsTopic,
    //           eNewsTopic: vm.eNewsTopic,
    //           NewsUrl: vm.NewsLink,
    //           eNewsUrl: vm.eNewsLink,
    //           NewsContent: vm.NewsContent,
    //           eNewsContent: vm.eNewsContent,
    //           Archived: vm.NewsArchive,
    //           CSRF: vm.CSRF_Token,
    //         };

    //         axios.post(url, info).then(function (response) {
    //           if (response.data.Code == 200) {
    //             alert("您已成功新增新聞稿！");
    //             document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/news?no=${vm.RegNo}`;
    //           } else if (
    //             response.data.Code == 251 ||
    //             response.data.Code == 500
    //           ) {
    //             alert("系統忙碌，請稍後再試！");
    //             document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/news?no=${vm.RegNo}`;
    //           } else if (response.data.Code == 252) {
    //             document.location.href = `https://www.chanchao.com.tw/`;
    //           }
    //         });
    //       }
    //     }
    //   } else {
    //     if (!vm.eNewsTopic || !vm.eNewsContent) {
    //       $("html,body").animate({ scrollTop: 0 }, "slow");
    //       alert("輸入欄位不完整，請重新檢查！");

    //       if (!vm.NewsTopic) {
    //         $("#error2").html(
    //           "<span class='errorTextArea'>請填寫此欄位</span>"
    //         );
    //         $("#error").html("<p class='errorTextArea'></p>");

    //         if (!vm.NewsContent) {
    //           $("#error").html("<p class='errorTextArea'>請填寫此欄位</p>");
    //         }
    //       } else {
    //         $("#error2").html("<span class='errorTextArea'></span>");
    //         $("#error").html("<p class='errorTextArea'>請填寫此欄位</p>");
    //       }
    //     } else {
    //       if (!vm.eNewsContent) {
    //         alert("輸入欄位不完整，請重新檢查！");
    //         $("#error").html("<p class='errorTextArea'>請填寫此欄位</p>");
    //       } else {
    //         // vm.NewsContent = CKEDITOR.instances['NewsContent'].getData()
    //         // vm.eNewsContent = CKEDITOR.instances['eNewsContent'].getData()

    //         const url = "/apiExhibitors/ExhibitorNews/";

    //         const info = {
    //           RegNo: vm.RegNo,
    //           NewsTopic: vm.NewsTopic,
    //           eNewsTopic: vm.eNewsTopic,
    //           NewsUrl: vm.NewsLink,
    //           eNewsUrl: vm.eNewsLink,
    //           NewsContent: vm.NewsContent,
    //           eNewsContent: vm.eNewsContent,
    //           Archived: vm.NewsArchive,
    //           CSRF: vm.CSRF_Token,
    //         };

    //         axios.post(url, info).then(function (response) {
    //           if (response.data.Code == 200) {
    //             alert("您已成功新增新聞稿！");
    //             document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/news?no=${vm.RegNo}`;
    //           } else if (
    //             response.data.Code == 251 ||
    //             response.data.Code == 500
    //           ) {
    //             alert("系統忙碌，請稍後再試！");
    //             document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/news?no=${vm.RegNo}`;
    //           } else if (response.data.Code == 252) {
    //             document.location.href = `https://www.chanchao.com.tw/`;
    //           }
    //         });
    //       }
    //     }
    //   }
    // },

    AddNews() {
      const vm = this;

      // 判斷要驗證的欄位（根據 LocalExh 切換）
      const topicField = vm.LocalExh ? "NewsTopic" : "eNewsTopic";
      const contentField = vm.LocalExh ? "NewsContent" : "eNewsContent";

      const topicValue = vm[topicField];
      const contentValue = vm[contentField];

      // 驗證欄位是否完整
      if (!topicValue || !contentValue) {
        $("html,body").animate({ scrollTop: 0 }, "slow");
        alert("輸入欄位不完整，請重新檢查！");

        // 動態塞錯誤訊息
        $("#error2").html(
          !topicValue ? "<span class='errorTextArea'>請填寫此欄位</span>" : ""
        );
        $("#error").html(
          !contentValue ? "<p class='errorTextArea'>請填寫此欄位</p>" : ""
        );

        return;
      }

      // API 送出資料
      const url = "/apiExhibitors/ExhibitorNews/";
      const info = {
        RegNo: vm.RegNo,
        NewsTopic: vm.NewsTopic,
        eNewsTopic: vm.eNewsTopic,
        NewsUrl: vm.NewsLink,
        eNewsUrl: vm.eNewsLink,
        NewsContent: vm.NewsContent,
        eNewsContent: vm.eNewsContent,
        Archived: vm.NewsArchive,
        CSRF: vm.CSRF_Token,
      };

      axios.post(url, info).then((response) => {
        const code = response.data.Code;
        if (code === 200) {
          alert("您已成功新增新聞稿！");
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/news?no=${vm.RegNo}`;
        } else if (code === 251 || code === 500) {
          alert("系統忙碌，請稍後再試！");
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/news?no=${vm.RegNo}`;
        } else if (code === 252) {
          document.location.href = `https://www.chanchao.com.tw/`;
        }
      });
    },

    AddEnNews() {
      const vm = this;

      if (!vm.eNewsTopic || !vm.eNewsContent) {
        $("html,body").animate({ scrollTop: 0 }, "slow");
        alert("There are incomplete fields, please check again.");

        if (!vm.eNewsTopic) {
          $("#error2").html(
            "<span class='errorTextArea'>This field is required.</span>"
          );
          $("#error").html("<p class='errorTextArea'></p>");

          if (!vm.eNewsContent) {
            $("#error").html(
              "<p class='errorTextArea'>This field is required.</p>"
            );
          }
        } else {
          $("#error2").html("<span class='errorTextArea'></span>");
          $("#error").html(
            "<p class='errorTextArea'>This field is required.</p>"
          );
        }
      } else {
        if (!vm.eNewsContent) {
          alert("There are incomplete fields, please check again.");
          $("#error").html(
            "<p class='errorTextArea'>This field is required.</p>"
          );
        } else {
          const url = "/apiExhibitors/ExhibitorNews/";

          const info = {
            RegNo: vm.RegNo,
            NewsTopic: vm.NewsTopic,
            eNewsTopic: vm.eNewsTopic,
            NewsUrl: vm.NewsLink,
            eNewsUrl: vm.eNewsLink,
            NewsContent: vm.NewsContent,
            eNewsContent: vm.eNewsContent,
            Archived: vm.NewsArchive,
            CSRF: vm.CSRF_Token,
          };

          axios.post(url, info).then(function (response) {
            if (response.data.Code == 200) {
              alert("Successfully published news!");
              document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/news?no=${vm.RegNo}`;
            } else if (response.data.Code == 251) {
              alert("System is busy, please try again later.");
              document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/news?no=${vm.RegNo}`;
            } else if (response.data.Code == 252) {
              document.location.href = `https://www.chanchao.com.tw/`;
            } else if (response.data.Code == 500) {
              alert("System is busy, please try again later.");
            }
          });
        }
      }
    },

    backNewsPage() {
      const vm = this;
      if (vm.lang == "tw") {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/news?no=${vm.RegNo}`;
      } else {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/news?no=${vm.RegNo}`;
      }
    },
  },

  created() {
    const vm = this;

    //語系會自動抓html lang tag

    //CSRF_Token
    axios
      .get("https://www.chanchao.com.tw/apiExhibitors/CSRF_Token")
      .then((response) => {
        vm.CSRF_Token = response.data;
      });

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/UserID`)
      .then((response) => {
        vm.UserId = response.data;
      });

    //url取出展碼
    let currentUrl = location.href;
    vm.RegNo = currentUrl.split("no=")[1];

    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=tw`
      )
      .then((response) => {
        if (response.data.Code == 200) {
          let ExpoLocation = response.data.Data.ExpoLocation;

          if (ExpoLocation === "T" || ExpoLocation === null) {
            vm.LocalExh = true;
          } else {
            vm.LocalExh = false;
          }
        }
      });
  },
};
</script>

<style lang="scss"></style>
